module.exports = __webpack_public_path__ + "static/img/img_consent.0a93a0c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/figmatest/img_consent.gif
// module id = IlYJ
// module chunks = 1